module.exports = __webpack_public_path__ + "img/FreeTraining-2.fbee0cf2.png";